import { env } from '.'
import parseQueryString from './parseQueryString'

export default function getWebsiteUrlWithParams({ path, search }) {
  const href = `https://${env('REACT_APP_WEBSITE_URL')}`
  const { utm_source: utmSource } = search ? parseQueryString(search) : ''
  return `${href}${path || ''}?${utmSource ? `utm_source=${utmSource}` : ''}`
}
